import { render, staticRenderFns } from "./frightTool.vue?vue&type=template&id=299dac10"
import script from "./frightTool.vue?vue&type=script&lang=js"
export * from "./frightTool.vue?vue&type=script&lang=js"
import style0 from "./frightTool.vue?vue&type=style&index=0&id=299dac10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports